import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { CountryIso31661Alpha2Code } from '../../../../../aumico-lib-core-fe/src/lib';

@Component({
    selector: 'country-filter-drop-down',
    templateUrl: './country-filter-drop-down.component.html',
    styleUrls: ['./country-filter-drop-down.component.scss'],
})
export class CountryFilterDropDownComponent {
    @Input() selectedCountries: CountryIso31661Alpha2Code[] = [];
    @Output() countryChange = new EventEmitter<CountryIso31661Alpha2Code[]>();

    openedFlyout = false;
    @Input() rightAlignment: boolean = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    statusOptions = Object.values(CountryIso31661Alpha2Code).map((country) => ({ label: country, value: country }));
    @Input() singleSelection = false;

    isFilterActive: boolean = this.selectedCountries.length > 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedCountries']) {
            this.isFilterActive = this.selectedCountries && this.selectedCountries.length > 0;
        }
    }

    toggleCountrySelection(value: CountryIso31661Alpha2Code): void {
        if (this.singleSelection) {
            this.selectedCountries = [value];
            this.applyFilter();
            return;
        }

        const isCurrentlySelected = this.selectedCountries.includes(value);
        this.onCountrySelection(value, !isCurrentlySelected);
    }

    onCountrySelection(value: CountryIso31661Alpha2Code, checked: boolean) {
        if (this.singleSelection) {
            this.selectedCountries = [];
            this.selectedCountries.push(value);
            this.applyFilter();
            return;
        }

        if (checked) {
            this.selectedCountries.push(value);
        } else {
            this.selectedCountries = this.selectedCountries.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left,
        };

        const diffrence = rect.left - rect.right;

        if (this.rightAlignment) {
            this.flyoutPosition.left += diffrence;
        }

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.isFilterActive = this.selectedCountries.length > 0;
        this.closeFlyout();
        this.countryChange.emit(this.selectedCountries);
    }

    clearFilter(): void {
        this.selectedCountries = [];
        this.isFilterActive = false;
        this.closeFlyout();
        this.countryChange.emit(this.selectedCountries);
    }
}
